// src/stores/useMachineStore.js

import { defineStore } from "pinia";
import axios from "@/helpers/axiosConfig";

export const useMachineStore = defineStore("machine", {
  state: () => ({
    machines: [],
    loading: false,
    error: null,
  }),
  actions: {
    async fetchMachines(language) {
      this.loading = true;
      this.error = null;
      try {
        const response = await axios.get(`/machines_${language}`);
        this.machines = response.data;
        //console.log("Staplerdaten geladen:", this.machines);
      } catch (err) {
        this.error = `Fehler beim Laden der Staplerdaten: ${err.message}`;
        console.error("API-Fehler:", err.response || err);
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    getMachineByInternalno(internalno) {
      console.log("Suche Maschine mit interner Nummer:", this.machines);
      return (
        this.machines.find((machine) => machine.internalno === internalno) ||
        null
      );
    },
    async fetchMachineByInternalno(internalno, language) {
      this.loading = true;
      this.error = null;
      try {
        const response = await axios.get(`/machines/${internalno}_${language}`);
        const fetchedMachine = response.data;
        // Optional: hinzufügen, falls sie noch nicht existiert
        const exists = this.machines.some(
          (machine) => machine.internalno === internalno
        );
        if (!exists) {
          this.machines.push(fetchedMachine);
        }
        return fetchedMachine;
      } catch (err) {
        this.error = `Fehler beim Laden der Maschinendetails: ${err.message}`;
        console.error("API-Fehler:", err.response || err);
        console.error(err);
        return null;
      } finally {
        this.loading = false;
      }
    },

    // NEU: Such-Funktion
    searchMachines(query) {
      if (!query || !query.trim()) {
        // Wenn kein Suchbegriff vorhanden ist, direkt alles zurückgeben
        return this.machines;
      }
      const lowerQuery = query.toLowerCase();
      // Maschinen filtern, wenn der Suchbegriff in irgendeinem Feld vorkommt
      return this.machines.filter((machine) => {
        return Object.values(machine).some((val) => {
          if (!val) return false;
          return val.toString().toLowerCase().includes(lowerQuery);
        });
      });
    },
  },
});
